import React from 'react';
import styled from 'styled-components';
import {HomeSectionHeader} from './SectionHeader';
import {HomeSectionCard, HomeSectionCardProps} from './SectionCard';

const HomeSectionWrapper = styled.div`
    width: 100%;
    max-width: 1200px;
    box-sizing: border-box;
    padding: 32px 0 16px;
`;

const HomeSectionCards = styled.div`
    display: flex;
    flex-direction: column;
    margin: 32px 16px 0 16px;
    box-sizing: border-box;

    ${p => p.theme.breakpoints.up('sm')} {
        flex-flow: row wrap;
        margin: 48px 32px 0 32px;
    }
`;

export interface HomeSectionProps {
    title: string;
    background: string;
    backgroundAlt?: string;
    cardsLogoBoxHeight?: number;
    cardsLogoBoxMobileHeight?: number;
    cards: HomeSectionCardProps[];
}

export const HomeSection: React.FC<HomeSectionProps> = ({
    title,
    background,
    backgroundAlt = 'Section background image',
    cards = [],
    cardsLogoBoxHeight,
    cardsLogoBoxMobileHeight
}): JSX.Element => {
    const length = cards.length;
    let anchorId = '';
    if (title) {
        anchorId = title.toLowerCase();
    }

    return (
        <HomeSectionWrapper id={anchorId}>
            <HomeSectionHeader title={title} background={background} backgroundAlt={backgroundAlt} />
            <HomeSectionCards>
                {cards.map((card, i) => (
                    <HomeSectionCard key={`${card.title}_${i}`} {...card} numCards={length} logoBoxHeight={{desktop: cardsLogoBoxHeight, mobile: cardsLogoBoxMobileHeight}} />
                ))}
            </HomeSectionCards>
        </HomeSectionWrapper>
    );
};
